/**
 * @generated SignedSource<<5ed2974b856bff07221cf0bc9d95382a>>
 * @relayHash a318c6cf4c9eb18c3a3da37ca363ccc1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3ad70d54f9d11fe1f125e5eb474fba169e08e62a8d9e0d7d7b53b29042f9ea48

import type { ConcreteRequest, Query } from 'relay-runtime';
export type NthUserTemplatesAllTemplatesQuery$variables = {
  usePersonalSpace: boolean;
};
export type NthUserTemplatesAllTemplatesQuery$data = {
  readonly allTemplates: {
    readonly nodes: ReadonlyArray<{
      readonly blueprintModuleCompleteKey: string | null | undefined;
      readonly contentBlueprintId: string | null | undefined;
      readonly itemModuleCompleteKey: string | null | undefined;
      readonly name: string | null | undefined;
      readonly templateId: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type NthUserTemplatesAllTemplatesQuery = {
  response: NthUserTemplatesAllTemplatesQuery$data;
  variables: NthUserTemplatesAllTemplatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "usePersonalSpace"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "usePersonalSpace",
        "variableName": "usePersonalSpace"
      }
    ],
    "concreteType": "PaginatedTemplateInfoList",
    "kind": "LinkedField",
    "name": "allTemplates",
    "plural": false,
    "selections": [
      {
        "concreteType": "TemplateInfo",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "templateId"
          },
          {
            "kind": "ScalarField",
            "name": "contentBlueprintId"
          },
          {
            "kind": "ScalarField",
            "name": "blueprintModuleCompleteKey"
          },
          {
            "kind": "ScalarField",
            "name": "itemModuleCompleteKey"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "NthUserTemplatesAllTemplatesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NthUserTemplatesAllTemplatesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a318c6cf4c9eb18c3a3da37ca363ccc1",
    "id": "3ad70d54f9d11fe1f125e5eb474fba169e08e62a8d9e0d7d7b53b29042f9ea48",
    "metadata": {},
    "name": "NthUserTemplatesAllTemplatesQuery",
    "operationKind": "query",
    "text": "query NthUserTemplatesAllTemplatesQuery($usePersonalSpace:Boolean!){allTemplates(usePersonalSpace:$usePersonalSpace){nodes{templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,name}}}"
  }
};
})();

(node as any).hash = "832d03e1fc006e98443bb93d481b50bc";

export default node;
